import { auth, notifications, siteSettingsService } from '@/services';

(function (angular) {
    'use strict';

    angular.module('app')
        .controller('adminPollsController', adminPollsController);

    adminPollsController.$inject = [
        'Polls',
        'PollsApi',
        'SettingsApi',
        'thisSiteSettings',
    ];

    function adminPollsController(
        Polls,
        PollsApi,
        SettingsApi,
        thisSiteSettings,
    ) {
        const vm = this;

        // properties
        vm.permissionChecks = {
            canManageSettings: auth.hasPermission('sites.set.settings'),
        };
        vm.isLoading = true;
        vm.isInitialised = false;
        vm.polls = {};
        vm.filters = {
            title: '',
            status: '',
            only_active: 0,
            page: 1,
            page_size: 15,
            hide_event_polls: false,
            include_dont_show_on_polls: true,
        };
        vm.activeOptions = [
            { label: 'All', value: 0 },
            { label: 'Only Active', value: 1 },
        ];
        vm.statusOptions = [
            { label: 'All', value: ''},
            { label: 'Pending', value: 'pending' },
            { label: 'Approved', value: 'approved' },
            { label: 'Rejected', value: 'rejected' },
        ];
        vm.editedPendingPolls = []; // holds the ID's of pending polls, in case they're approved, so we can add a style
        vm.settings = {
            // default values, overridden in bootstrap method.
            chargePrice: 0,
            chargeViaStripe: false,
        };
        vm.currencySymbol = thisSiteSettings.currency_symbol;

        // methods
        vm.getPolls = getPolls;
        vm.createPoll = createPoll;
        vm.editPoll = editPoll;
        vm.pollIsActive = pollIsActive;

        vm.getPollSettings = getPollSettings;
        vm.setPollSettings = setPollSettings;

        /**
         * Initialises the controller.
         *
         * @returns {Promise<void>}
         */
        async function bootstrap(): Promise<void> {
            // load site settings
            await siteSettingsService.load();
            // cache settings values we use
            const siteSettings = siteSettingsService.all();
            vm.settings.chargePrice = siteSettings.poll_charge_price;
            vm.settings.chargeViaStripe = siteSettings.poll_charge_accept_online_payments;

            getPolls();
            getPollSettings();

            vm.isInitialised = true;
        }

        /**
         * Retrieves settings from the API. Shame we can't specify an array of keys.
         * @return {void}
         */
        function getPollSettings() {
            SettingsApi.get({}, function (response) {
                if (response && response.data && response.data.poll_charge_enabled) {
                    vm.charge.enabled = response.data.poll_charge_enabled;
                    vm.charge.price = response.data.poll_charge_price;
                    vm.charge.online = response.data.poll_charge_accept_online_payments;
                }
            });
        }

        /**
         * Sets settings to the API.
         * @return {void}
         */
        function setPollSettings() {
            SettingsApi.save({
                settings: {
                    poll_charge_price: vm.settings.chargePrice,
                    poll_charge_accept_online_payments: vm.settings.chargeViaStripe,
                },
            }, response => {
                if (response && response.data && response.data.poll_charge_enabled) {
                    vm.settings.chargePrice = response.data.poll_charge_price;
                    vm.settings.chargeViaStripe = response.data.poll_charge_accept_online_payments;
                }

                notifications.display({
                    message: '',
                    title: 'Settings updated',
                    theme: 'success',
                });
            });
        }

        /**
         * Retrieves polls from the API
         * @return {void}
         */
        function getPolls() {
            vm.isLoading = true;

            PollsApi.get(vm.filters, function handleGetPollsResponse(response) {
                vm.polls = response;
                vm.isLoading = false;
            }, function handleGetPollsError() {
                vm.isLoading = false;
            });
        }

        /**
         * Shows the create poll modal then refreshes the data
         * @return {void}
         */
        function createPoll() {
            Polls.managePoll();
        }

        /**
         * Shows the edit poll modal then refreshes the data
         * @param  {object} poll - Poll containing id
         * @return {void}
         */
        function editPoll(poll) {
            if (poll.status === 'pending') {
                vm.editedPendingPolls.push(poll.id);
            }

            Polls.managePoll(poll.id).result.then(function (updatedPoll) {

                // Find and update the poll on this page
                angular.forEach(vm.polls.data, function (poll, index) {
                    if (poll.id === updatedPoll.id) {
                        if (vm.editedPendingPolls.indexOf(updatedPoll.id) !== -1 && updatedPoll.status === 'approved') {
                            // this poll has been changed from pending to approved
                            updatedPoll.recentlyApproved = true;
                        }

                        vm.polls.data[index] = angular.merge(vm.polls.data[index], updatedPoll);
                    }
                });

            });
        }

        /**
         *  Determines whether a poll is currently active
         *
         * @param {Object} poll
         * @returns {Boolean}
         */
        function pollIsActive(poll) {
            var now = new Date().valueOf();
            var startsAt = new Date(poll.starts_at).valueOf();
            var endsAt = new Date(poll.ends_at).valueOf();

            return (now > startsAt) && (now < endsAt);
        }

        // init
        bootstrap();
    }

}(angular));
